import getLayoutItem from './layoutItem';

const ListItem = getLayoutItem('index');

export default ListItem;
